import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  episode:null,
  audioUrl: null,
};

const audioPlayerSlice = createSlice({
  name: "audioPlay",
  initialState,
  reducers: {
    setAudio: (state, action) => {
      const { audioUrl, episode } = action?.payload;
      state.episode = episode;
      state.audioUrl = audioUrl;
    },
    clearAudio: (state) => {
      state.episode = null;
      state.audioUrl = null;
    },
  },
});

export const selectCurrentAudioURL = (state) => state?.audioPlay?.audioUrl;
export const selectCurrentEpisode = (state) => state?.audioPlay?.episode;

export const { setAudio, clearAudio } = audioPlayerSlice.actions;
export default audioPlayerSlice.reducer;
